<div class="flex flex-col items-center">
  <svg-icon class="w-60" [src]="'palm'"></svg-icon>
  <div class="flex flex-col items-center gap-5 mt-30 font-main text-navy-90">
    <p class="text-4xl">{{ 'noRolePage.info' | translate }}</p>
    <p class="text-base">{{ 'noRolePage.contactSupport' | translate }}</p>
    <app-new-button
      data-test-id="logout-btn"
      [type]="'primary'"
      [size]="'responsive'"
      [svgIconPath]="'user-menu/logout'"
      (click)="logout()"
    >
      {{ 'noRolePage.logout' | translate }}
    </app-new-button>
  </div>
</div>
